import React from 'react';
import Header from '../../../components/Header';
import Panel from '../../../components/Panel';
import { CSidebar } from '../../../components/Sidebar';
import { Container } from '../../../styles/global';
import { Loader } from './styles';

const MembersDashboard: React.FC = () => {
    return (
        <div style={{display: 'flex', height: '100%'}}>
            <div style={{height: '100%'}}>
                <CSidebar />
            </div>
            <div style={{display: 'block', width: '100%'}}>
                <Header /> 

                <Container>
                    <Panel titulo='Dashboard de Membros'>
                        <Loader src="https://sigaaguas.org.br/portal/apps/opsdashboard/index.html#/39a6fedbb14e472ab0d3e1198a09c5aa" frameborder="0" title='ArcGIS Dashboard'></Loader>
                    </Panel>
                </Container>
            </div>
        </div> 
    );
};

export default MembersDashboard;